import {
  useCurrentWorkspace,
  useRoutineFilter,
  useSetRoutineFilter,
} from '@gripp/shared-logic';
import { useTranslation } from 'react-i18next';
import { EntitySearchInput } from './entitySearchInput';

export const RoutineSearchInput = () => {
  const { t } = useTranslation();
  const { data: filter } = useRoutineFilter();
  const { mutateAsync } = useSetRoutineFilter();
  const currentWorkspace = useCurrentWorkspace();

  const onSearch = async (keyword: string) => {
    if (!filter) return;
    filter.workspaceId = currentWorkspace?.id;
    filter.keyword = keyword;
    await mutateAsync(filter);
  };

  return (
    <EntitySearchInput
      filter={filter}
      onSearch={onSearch}
      placeholder={t('routine.filter.searchPlaceholder')}
      disableInitialSearch
    />
  );
};
